import { Button } from 'components/Button/Button';
import { PasswordRequirementsAndMatch } from 'components/PasswordRequirementsAndMatch/PasswordRequirementsAndMatch';
import { TextInput } from 'components/TextInput/TextInput';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from './messages';
import { UpdatePasswordState } from './types/UpdatePasswordState';

const ChangePassword = ({
  oldPasswordChanged,
  newPasswordChanged,
  confirmPasswordChanged,
  onContinue,
  buttonDisabled,
  loading,
  updatePasswordState,
  passwordValidationChanged,
}: {
  oldPasswordChanged?: (value: string) => void;
  newPasswordChanged?: (value: string) => void;
  confirmPasswordChanged?: (value: string) => void;
  onContinue?: () => void;
  buttonDisabled?: boolean;
  loading?: boolean;
  updatePasswordState?: UpdatePasswordState;
  passwordValidationChanged?: (value: boolean) => void;
}) => {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const changePasswordMessages = messages[language].changePassword;
  async function onSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!buttonDisabled && onContinue) onContinue();
  }

  return (
    <form onSubmit={onSubmit}>
      <h1 className="font-semibold leading-9 pl-11 pr-11 text-2.5x1 text-center">
        {changePasswordMessages.heading}
      </h1>
      <p className="leading-9 pl-11 pr-11 pt-2 text-2x1 text-body-text text-center">
        {changePasswordMessages.subHeading}
      </p>
      <div className="bg-background overflow-hidden p-5 mb-4 rounded-lg shadow-xl transition-all mt-6">
        <TextInput
          name="oldPassword"
          type="password"
          label={changePasswordMessages.oldPasswordLabel}
          onChange={value => {
            if (oldPasswordChanged) oldPasswordChanged(value as string);
          }}
        />
        <TextInput
          name="newPassword"
          type="password"
          label={changePasswordMessages.newPasswordLabel}
          onChange={value => {
            if (newPasswordChanged) newPasswordChanged(value as string);
          }}
        />
        <TextInput
          name="confirmPassword"
          type="password"
          label={changePasswordMessages.confirmPasswordLabel}
          onChange={value => {
            if (confirmPasswordChanged) confirmPasswordChanged(value as string);
          }}
        />
      </div>
      <PasswordRequirementsAndMatch
        passwordValidationChanged={passwordValidationChanged}
        passwordState={updatePasswordState}
        isPasswordMatch={true}
      />
      <Button
        onClick={onSubmit}
        type="submit"
        disabled={buttonDisabled}
        continue={!loading}
        loading={loading}
        w-full
        flex
        justify-center
        py-2
        px-4
        text-sm
        font-normal
        rounded-md
        text-white
        transition
        duration-150
        ease-in-out
        bg-vivid-blue>
        {!loading && changePasswordMessages.nextButton}
      </Button>
    </form>
  );
};

export default ChangePassword;
